import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConferenceComponent } from './conference.component';
import { AudioVideoConferenceModule } from './audio-video-conference/audio-video-conference.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

@NgModule({
  declarations: [
    ConferenceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AudioVideoConferenceModule,
    SkeletonLoaderModule
  ],
  exports: [
    ConferenceComponent
  ],
  entryComponents: [
    ConferenceComponent
  ],
  // The dead, commented-out markup in conference.component.html (preserved for fidelity)
  // references `candidate-profile`, an AngularJS-only element; schema suppresses the
  // "unknown element" build error the same way audio-video-conference.module.ts does,
  // even though that markup is inert (commented) here.
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConferenceModule { }
